var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { date } from './date.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var UserTestService = /** @class */ (function () {
    function UserTestService(http, baseUrl) {
        this.http = http;
        this.baseUrl = baseUrl;
        this.apiUrl = this.baseUrl + "api/user/tests";
    }
    Object.defineProperty(UserTestService.prototype, "url", {
        get: function () {
            return this.apiUrl;
        },
        enumerable: true,
        configurable: true
    });
    UserTestService.prototype.getTestResults = function (userTestId) {
        return this.http.get(this.apiUrl + "/" + userTestId + "/results");
    };
    UserTestService.prototype.approveTest = function (userTestId, score) {
        return this.http
            .patch(this.apiUrl + "/" + userTestId + "/score", { score: score })
            .pipe(tap(function (userTest) { return date(userTest, 'scheduledStartTime', 'expiryDate'); }));
    };
    UserTestService.prototype.getMedia = function (userBlockId) {
        return this.http.get(this.apiUrl + "/media/" + userBlockId, {
            responseType: 'blob'
        });
    };
    UserTestService.prototype.scheduleTestStartTime = function (userTest, testStartDateTime) {
        return this.http
            .patch(this.apiUrl + "/" + userTest.id + "/schedule", { testStartDateTime: testStartDateTime })
            .pipe(tap(function (userTest) { return date(userTest, 'scheduledStartTime', 'expiryDate'); }));
    };
    UserTestService.prototype.getSampleTests = function () {
        return this.http.get(this.apiUrl + "/sampleTests");
    };
    UserTestService.prototype.resetTest = function (userTestId) {
        return this.http
            .delete(this.apiUrl + "/" + userTestId)
            .pipe(tap(function (data) { return date(data, 'expiryDate', 'startDate', 'endDate', 'scheduledStartTime'); }));
    };
    UserTestService.prototype.updateUserTestLimits = function (userTestId, params) {
        return this.http
            .patch(this.apiUrl + "/" + userTestId + "/limits", __assign({}, params))
            .pipe(tap(function (data) { return date(data, 'expiryDate', 'startDate', 'endDate', 'scheduledStartTime'); }));
    };
    UserTestService.ngInjectableDef = i0.defineInjectable({ factory: function UserTestService_Factory() { return new UserTestService(i0.inject(i1.HttpClient), i0.inject("BASE_URL")); }, token: UserTestService, providedIn: "root" });
    return UserTestService;
}());
export { UserTestService };
